import React, { useRef, useState } from "react";
import img1 from "../../assets/img/Home/card-cover.png";
import img2 from "../../assets/img/Home/Rectangle 23.png";
import img3 from "../../assets/img/Home/Rectangle 25.png";
import Slider from "react-slick";
import PlaceCard from "../common/PlaceCard";
import { SampleNextArrow, SamplePrevArrow } from "../shared/Arrow";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useAxios";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const SimilarPlace = () => {
 
  const slider1 = useRef();
  const [inforesidencedetail, setinforesidencedetail] = useState([]) //city //start //end //count
  const {code,slug}=useParams()
  const apiGetresidencedetailInfo = useFetch({
    method: "get",
    url: `api/residences/related/${code}`,
    noHeader: true,
    trigger: true,
    argFunc:(res)=>setinforesidencedetail(res.data)
  });
  console.log(inforesidencedetail)

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: inforesidencedetail.length >= 4 ?  4: inforesidencedetail.length,
    slidesToScroll: 1,
    rtl:false,
    centerPadding: '3%',
    className: "carousel-padding",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: inforesidencedetail.length >= 3 ?  3: inforesidencedetail.length,
          slidesToScroll: inforesidencedetail.length >= 3 ?  3: inforesidencedetail.length,
          infinite: true,
      
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: inforesidencedetail.length >= 3 ?  3: inforesidencedetail.length,
          slidesToScroll: inforesidencedetail.length >= 3 ?  3: inforesidencedetail.length,
          infinite: true,
      
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: inforesidencedetail.length >= 2 ?  2: inforesidencedetail.length,
          slidesToScroll: inforesidencedetail.length >= 2 ?  2: inforesidencedetail.length,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: inforesidencedetail.length >= 2 ?  2: inforesidencedetail.length,
          slidesToScroll: inforesidencedetail.length >= 2 ?  2: inforesidencedetail.length,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: inforesidencedetail.length >= 1 ?  1: inforesidencedetail.length,
          slidesToScroll: inforesidencedetail.length >= 1 ?  1: inforesidencedetail.length,
        }
      }
    ]
  };
  const next = () => {
    slider1.current.slickNext();
  };
  const previous = () => {
    slider1.current.slickPrev();
  };
  return (
  <div className="container SimilarPlace slider-con">
       <div className=" flex justify-between items-center mt-[100px]">
     <div className="">
        <h4 className="font-[700] text-[40px] text-[#292D32]">
        اقامتگاه مشابه    </h4>
        <div className="text-[20px] mt-[10px] text-[#797D82]">
        همچنین سایر  اقامتگاه های مشابه با این اقاتگاه را ببینید
          </div>
      </div>
      <div className="flex">
          <SampleNextArrow onClick={next} />
          <SamplePrevArrow onClick={previous} />
        </div>
     </div>
      <div className="Popularcity--slider mt-[40px]">
      {inforesidencedetail ?  <Slider ref={slider => (slider1.current = slider)} {...settings}>
        {inforesidencedetail && inforesidencedetail.map(i=><PlaceCard
              img={`${i.thumbnail?.path}`}
              isfast={i.instant_reserve === 1? true:false}
              rate={i.rating_value}
              info={i.address}
              title={i.title}
              key={i.id}
              cost={i.price}
              tip={i.special_discount_in_24}
              code={i.code}
              slug={i.slug}
              room={i.rooms_count}
              city={i.city}
              type={i.type}
          />)  }
   
        </Slider>:
        <div className="container" >
        <SkeletonTheme height={400} borderRadius={10}>
          <div className="grid grid-cols-4 gap-[20px]">
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
          
          </div>
        </SkeletonTheme>
      </div>}
      </div>

  </div>
  );
};

export default SimilarPlace;
